var _path, _path2, _rect, _rect2, _rect3, _path3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 144 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M50.419 17.542c4.7-1.15 9.745-.796 13.667 1.452 4.14 2.41 6.803 6.48 10.143 9.819 8.931 8.988 20.964 9.558 32.45 13.519 9.118 3.165 26.612 7.165 24.814 19.578-.827 5.61-6.28 9.6-11.533 12.383-5.253 2.782-11.105 5.285-14.271 10.202-2.761 4.26-2.813 9.497-4.145 14.307-2.18 7.732-8.032 14.579-15.58 18.141-19.468 9.285-27.194-10.638-41.636-16.941-4.288-1.875-9.25-1.92-13.997-2.463-14.129-1.437-17.318-13.34-15.18-25.79 2.527-14.477 12.157-26.79 19.337-39.766 2.083-3.747 4.246-7.626 7.677-10.47 2.252-1.812 5.197-3.207 8.254-3.97z",
    fill: "#89DBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.62 97.451a.925.925 0 00.55.173h25.928A11.704 11.704 0 0055 91.21c0-6.494-5.264-11.758-11.759-11.758a11.76 11.76 0 00-10.66 6.79 6.414 6.414 0 00-5.962 11.21z",
    fill: "#7BCEEA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 88.452,
    width: 62,
    height: 8,
    rx: 1,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 82.452,
    width: 54,
    height: 6,
    rx: 1,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 44.452,
    width: 54,
    height: 6,
    rx: 1,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 41.241a1 1 0 01.59-.912l26-11.693a1 1 0 01.82 0l26 11.693a1 1 0 01.59.912v2.21a1 1 0 01-1 1H47a1 1 0 01-1-1v-2.21z",
    fill: "#4FBEE3",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 55.452,
    width: 6,
    height: 22,
    rx: 1,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 55.452,
    width: 6,
    height: 22,
    rx: 1,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 55.452,
    width: 6,
    height: 22,
    rx: 1,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 77.452,
    width: 8,
    height: 5,
    rx: 1,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 50.452,
    width: 8,
    height: 5,
    rx: 1,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 77.452,
    width: 8,
    height: 5,
    rx: 1,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 50.452,
    width: 8,
    height: 5,
    rx: 1,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 77.452,
    width: 8,
    height: 5,
    rx: 1,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 50.452,
    width: 8,
    height: 5,
    rx: 1,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#25557B",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M28.5 96.952h89"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 84.452,
    r: 12,
    fill: "#fff",
    stroke: "#25557B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#25557B",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M105 79.452v10M110 84.452h-10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBank);
export default __webpack_public_path__ + "static/media/add-bank.3acf4803dd12f00f79f09aa2a8997d8f.svg";
export { ForwardRef as ReactComponent };